module.exports = __webpack_public_path__ + "static/media/mrec.c930e9c5.jpg";